var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRefresh } from 'react-admin';
import { Box, Grid, Button, CircularProgress } from '@mui/material';
import { filter } from '../../utils/componentWizard';
import SearchIcon from '@mui/icons-material/Search';
import SubjectsDatePicker from '../../utils/dateInputFilter';
var Spacer = function () { return _jsx(Box, { mb: 1, children: "\u00A0" }); };
var FilterList = function (_a) {
    // const [examsToDate, setExamsToDate] = useState({})
    // const [examsFromDate, setExamsFromDate] = useState({})
    var _b;
    var translate = _a.translate, search = _a.search, isLoading = _a.isLoading, filters = _a.filters, setFilters = _a.setFilters, params = _a.params;
    var refresh = useRefresh();
    var sessonStorageJSON = (_b = JSON.parse(sessionStorage.getItem("".concat(window.location.pathname, "_filter")))) !== null && _b !== void 0 ? _b : {};
    var newUpdatedFilters = __assign(__assign({}, filters), sessonStorageJSON);
    // useEffect(() => {
    //     setExamsToDate(newUpdatedFilters?.examsToDate)
    //     setExamsFromDate(newUpdatedFilters?.examsFromDate)
    // }, [])
    return (_jsxs(Grid, { container: true, spacing: 1, justifyContent: "start", paddingY: 2, children: [_jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, children: _jsx(SubjectsDatePicker, { filters: newUpdatedFilters, setFilters: setFilters, label: translate("pages.exam.fields.examFromDate"), name: "examFromDate", xs: 12, md: 4, minWidth: 180, minDate: new Date(2019, 8, 1), maxDate: new Date(), notNeedRequired: true }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, children: _jsx(SubjectsDatePicker, { filters: newUpdatedFilters, setFilters: setFilters, label: translate("pages.exam.fields.examToDate"), name: "examToDate", xs: 12, md: 4, minWidth: 180, minDate: new Date(2019, 8, 1), maxDate: new Date(), notNeedRequired: true }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, children: _jsx(filter.dropDownList, { filters: filters, setFilters: setFilters, label: translate("pages.exam.fields.eye"), name: "eye", minWidth: 120, options: params }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, children: _jsx(filter.dropDownList, { filters: filters, setFilters: setFilters, label: translate("pages.exam.fields.ai_model"), name: "ai_model", minWidth: 160, options: params }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, children: _jsx(filter.dropDownList, { filters: filters, setFilters: setFilters, label: translate("pages.exam.fields.risk_of_ad"), name: "risk_of_ad", minWidth: 140, options: params }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, children: _jsx(filter.textField, { filters: filters, setFilters: setFilters, label: translate("pages.exam.fields.confidence_level"), name: "confidence_Level", width: 140 }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, children: _jsx(filter.dropDownList, { filters: filters, setFilters: setFilters, label: translate("pages.exam.fields.status"), name: "status", minWidth: 140, options: params }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, children: _jsx(SubjectsDatePicker, { filters: filters, setFilters: setFilters, label: translate("pages.subject.fields.analyzeFromDate"), name: "analyzeFromDate", width: 140 }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, children: _jsx(SubjectsDatePicker, { filters: filters, setFilters: setFilters, label: translate("pages.subject.fields.analyzeToDate"), name: "analyzeToDate", width: 140 }) }), _jsx(Grid, { item: true, alignItems: "end", justifyContent: "end", children: _jsx(Button, { variant: "contained", disabled: isLoading, onClick: search, color: 'common', startIcon: _jsx(SearchIcon, { sx: {
                            animation: 'pulse 2s infinite ease-in-out',
                            '@keyframes pulse': {
                                '0%': {
                                    transform: 'scale(1)',
                                },
                                '50%': {
                                    transform: 'scale(1.5)',
                                },
                                '100%': {
                                    transform: 'scale(1)',
                                },
                            },
                        } }), sx: {
                        marginTop: "0.5em",
                        height: "3.3em",
                        width: "9em",
                        fontWeight: "900",
                        color: "#0d47a1",
                        borderRadius: '20px',
                        boxShadow: '0px 6px 8px gray',
                        opacity: "0.6",
                        transition: 'all 0.3s ease-in-out',
                        '&:hover': {
                            backgroundColor: '#1976d2',
                            color: 'white',
                            transform: 'scale(1.05)',
                            boxShadow: '0px 8px 12px rgba(0, 0, 0, 0.3)',
                            opacity: "1",
                        },
                        '&:active': {
                            transform: 'scale(0.95)',
                        },
                        '&:hover .MuiSvgIcon-root': {
                            animation: 'pulseHover 1.5s infinite ease-in-out',
                        },
                        '@keyframes pulseHover': {
                            '0%': {
                                transform: 'scale(1)',
                            },
                            '50%': {
                                transform: 'scale(1.8)',
                            },
                            '100%': {
                                transform: 'scale(1)',
                            },
                        },
                    }, children: isLoading ? _jsx(CircularProgress, { size: 24 }) : translate("common.search") }) })] }));
};
export default FilterList;
